import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import * as identify from "utils/treeUtils";
import { EllipsisWithTooltip } from "components/EllipsisWithTooltipText";
import { ConfigurationItem } from "./ConfigurationItem";
import { Icon } from "../Icon/Icon";

import styles from "./SummaryListItem.module.scss";

export const SummaryListItem = Scrivito.connect(
  ({ node, toggleNode, ...rest }) => {
    const { data } = node;
    const isAnyProduct = identify.isAnyProduct(data);
    const { folderName, id } = node.data;

    const handleToggleDetails = useCallback(() => {
      node.toggle();
      toggleNode(id);
    }, [node, toggleNode, id]);

    return (
      <div className="mw-100">
        {node ? (
          <>
            {!isAnyProduct ? (
              <div
                className={cx(
                  "d-flex  justify-content-between align-items-center border-bottom ms-2",
                  styles.item,
                )}
                style={rest.style}
              >
                <div className="d-flex align-items-center mw-100">
                  {node.children && (
                    <>
                      {node.children.length > 0 ? (
                        <>
                          <Icon
                            onClick={handleToggleDetails}
                            iconName={
                              node.isOpen
                                ? "fa-chevron-down"
                                : "fa-chevron-right"
                            }
                            className="icon-16 ms-1 me-3 cursor-pointer"
                          />
                        </>
                      ) : (
                        <div className={cx("ms-1", styles.noNodes)} />
                      )}
                    </>
                  )}

                  <div className="fw-bolder fs-md mw-95">
                    <EllipsisWithTooltip text={folderName} />
                  </div>
                </div>
              </div>
            ) : (
              <ConfigurationItem key={id} conf={node.data} style={rest.style} />
            )}
          </>
        ) : (
          <div
            className={cx(
              "d-flex justify-content-between align-items-center border-bottom fw-bolder ps-2_5",
              styles.item,
            )}
          >
            <div className="ms-5 fs-md mw-95">{folderName}</div>
          </div>
        )}
      </div>
    );
  },
);
